import { color } from "framer-motion";

export const ButtonStyle = {
  variant: "ghost",
  border: "3px solid",
  borderRadius: "10px",
  h: "45px",
  color: "black",
  bgColor: "white",
  _hover: { bgColor: "gray.700", color: "white" },
  colorScheme: "",
};
